import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

function ReportChannelLegend(props) {
  const { channelList } = props;
  return (
    <div className="row ml-2">
      {channelList.map((channel, index) => (
        <div className="float-left pl-1" style={{}} key={`${index}-widget`}>
          <FontAwesomeIcon icon="circle" color={channel.color} className="mr-2" size="xs" />
          <small>
            {channel.sensorName}
            {' '}
            -
            {' '}
            {channel.channelName}
          </small>
        </div>
      ))}
      { channelList.length === 0
      && (
        <span>
          No sensor channels currently available.
        </span>
      )}
    </div>
  );
}

ReportChannelLegend.propTypes = {
  channelList: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    sensorName: PropTypes.string,
    channelName: PropTypes.string,
  })).isRequired,
};

export default ReportChannelLegend;
